// One row of the chat "practise my vocabulary" picker.
//
// Card text keeps rendering as HTML in the visible spans (vocabulary text has
// rendered as HTML since #240), but every attribute value and tag is escaped:
// a quote in card text must stay inside its attribute instead of opening a new
// one (for example `Bonjour" onfocus=alert(1) x="`).
function escapeHtml (value) {
  return String(value).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ))
}

export function vocabListItemHtml (flashcard) {
  const tags = Array.isArray(flashcard.tags) ? flashcard.tags : []
  const tagsHtml = tags.length > 0
    ? `<div class="vocab-tags">${tags.map(tag => `<span class="vocab-tag">${escapeHtml(tag)}</span>`).join('')}</div>`
    : ''

  return `
    <div class="vocab-item position-relative mb-2"
         data-id="${escapeHtml(flashcard.id)}"
         data-term="${escapeHtml(flashcard.term)}"
         data-definition="${escapeHtml(flashcard.definition)}"
         data-tags="${escapeHtml(tags.join(','))}"
         data-date="${escapeHtml(flashcard.date)}">
      <div class="card vocab-card border-0">
        <div class="card-front p-3 d-flex justify-content-between align-items-center">
          <span class="vocab-text flex-grow-1">${flashcard.term}</span>
          <div class="d-flex align-items-center">
            ${tagsHtml}
            <button class="flip-btn btn btn-link p-0 ml-3">
              <i class="fa fa-language fa-lg text-muted"></i>
            </button>
          </div>
        </div>
        <div class="card-back p-3 d-flex justify-content-between align-items-center">
          <span class="vocab-text flex-grow-1">${flashcard.definition}</span>
          <div class="d-flex align-items-center">
            ${tagsHtml}
            <button class="flip-btn btn btn-link p-0 ml-3">
              <i class="fa fa-language fa-lg text-danger"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  `
}
